import { makeStyles } from '@material-ui/core';
export const useLMSCourseStyle=makeStyles({
    root:{
        height:"100%"
    },

    header:{

    },
    body:{

    },
    footer:{

    }


})